import { BrowserAndTabletView, MobileView } from 'components/DeviceDetect'
import CustomSlider from 'components/Slider'
import React from 'react'
import { Link } from 'react-router-dom'
import useConfig from 'store/ConfigProvider'
import { FlexContainer, Slide, SliderWrapper, SlideTitle } from './Slider.style'

const Slider = () => {
  const { sliders } = useConfig()

  const Sliders = type => {
    return (sliders || []).map(slide => {
      const link = slide.url
      const image_url = type === 'mobile' ? slide.image_mobile : slide.image

      const SliderComp =
        typeof link === 'string' && link.includes('http') ? 'a' : Link
      const url = typeof link == 'string' ? link : '#'
      const linkProps = {
        href: url,
        target: url.includes('http') ? '_blank' : undefined,
      }
      return (
        <Slide key={slide.id} image={image_url}>
          <SliderComp to={url} {...linkProps}>
            <FlexContainer>
              <SlideTitle>{slide.title || ''}</SlideTitle>
            </FlexContainer>
          </SliderComp>
        </Slide>
      )
    })
  }

  return (
    <SliderWrapper>
      <BrowserAndTabletView>
        <CustomSlider
          style={{ marginTop: '0' }}
          settings={{
            infinite: true,
            autoplay: true,
            autoplaySpeed: 3000,
          }}
        >
          {Sliders('desktop')}
        </CustomSlider>
      </BrowserAndTabletView>
      <MobileView>
        <CustomSlider
          style={{ marginTop: '0' }}
          settings={{ infinite: false, autoplay: true, autoplaySpeed: 4750 }}
        >
          {Sliders('mobile')}
        </CustomSlider>
      </MobileView>
    </SliderWrapper>
  )
}

export default Slider
